module.exports = __webpack_public_path__ + "static/media/stm-account.4214539d.svg";